import styled from 'styled-components'
import { Typography } from 'antd'
import { ReactNode } from 'react'

interface HeadData {
  value: string | number
  width?: string | number
}

interface TableData {
  type: 'description' | 'normal' | 'classification'
  data: any[]
  head?: HeadData[]
  label?: (string | number | ReactNode)[]
}
/**
 type description
 信息展示表格，label value 形式
 data 中元素的格式为
 { label: '根域名', value: 123 }

 type normal
 常见的表格，有表头和数据
 data 为二维数组，元素格式为
 ['0%', '攻击类型名称', '0/10'],顺序需要和表头顺序对应
 需传入 head 参数，用于表头的显示，格式为数组

 type classification
 有表头和label的表格
 数据格式暂定为列数据组合的数组，表头和label使用 head 和 label 参数传入
*/

export const InfoTable = (props: TableData) => {
  const { type, data, head, label } = props

  const RenderTableCell = (value, index = null) => {
    if (typeof value === 'object') {
      return <td>{value || '-'}</td>
    }
    return (
      <td key={index}>
        <Typography.Text
          ellipsis={{
            tooltip: {
              getPopupContainer: () => document.body,
            },
          }}
        >
          {value || '-'}
        </Typography.Text>
      </td>
    )
  }

  const DescriptionTable = () => (
    <table>
      {data?.map((item, index) => (
        <tr key={index}>
          <td style={{ width: item.width || 160 }}>{item.label}</td>
          {RenderTableCell(item.value)}
        </tr>
      ))}
    </table>
  )
  const NormalTable = () => (
    <table>
      <tr>
        {head?.map((item, index) => (
          <th key={index} style={{ width: item.width }}>
            {item.value || '-'}
          </th>
        ))}
      </tr>
      {data?.map((item, index) => (
        <tr key={index}>{item.map((e, i) => RenderTableCell(e, i))}</tr>
      ))}
    </table>
  )
  const ClassificationTable = () => (
    // const d = data?.[0].map((_, i) => data?.map(row => row[i]))
    <table>
      <tr>
        <th style={{ width: 130 }} />
        {head?.map((item, index) => (
          <th key={index}>{item.value || '-'}</th>
        ))}
      </tr>
      {data?.map((item, index) => (
        <tr key={index}>
          {RenderTableCell(label?.[index])}
          {item.map((e, i) => RenderTableCell(e, i))}
        </tr>
      ))}
    </table>
  )

  const tableMap = {
    description: DescriptionTable,
    normal: NormalTable,
    classification: ClassificationTable,
  }
  return <Container type={type}>{tableMap[type]()}</Container>
}

interface TableProps {
  type: string
}

const Container = styled.div<TableProps>`
  background: #fff;
  //padding: 10px;
  table {
    // width: 100%;
    border-collapse: separate;
    border-spacing: 0;
    border-radius: 6px;
    border: 1px solid #dcdfe3 !important;
    text-align: left;
    table-layout: fixed;
    td,
    th {
      width: 170px;
      border-right: 1px solid #dcdfe3;
      height: 40px;
      min-height: 40px;
      padding: 0 12px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      word-break: keep-all;
      vertical-align: middle;
    }
    td {
      border-top: 1px solid #dcdfe3;
      //white-space: nowrap;
      //overflow: hidden;
      //text-overflow: ellipsis;
      overflow-wrap: break-word;
    }
    td:last-child,
    th:last-child {
      border-right-color: transparent;
    }
    tr:first-of-type {
      td {
        border-top-color: transparent;
      }
    }
    tr {
      td:first-of-type {
        min-width: ${props =>
          props.type === 'description'
            ? '130px'
            : props.type === 'classification'
            ? '70px'
            : '140px'};
        background: ${props =>
          props.type === 'description' || props.type === 'classification' ? '#f0f1f1' : ''};
      }
    }
    tr:last-of-type td:first-of-type {
      border-bottom-left-radius: 6px;
    }
    tr:first-of-type td:first-of-type {
      border-top-left-radius: 6px;
    }
    th {
      font-weight: normal;
      background: #f0f1f1;
      &:first-of-type {
        border-top-left-radius: 6px;
      }
      &:last-of-type {
        border-top-right-radius: 6px;
      }
    }
    //tr > td {
    //  position: relative;
    //  padding: 16px;
    //  overflow-wrap: break-word;
    //}
  }
`
